import React from "react";
import { Box, Typography } from "@mui/material";
import TermsAndConditionsText from "@/main/account/voucherwallet/_components/terms-conditions-text";
import VoucherCodes from "@/main/account/voucherwallet/_components/voucher-codes";
import Link from "next/link";
import ImageWithFallback from "@/components/core/image-with-fallback";
interface VoucherInfoProps {
  voucherItem: {
    product_name: string;
    jit_product_name: string;
    jit_product_image: string;
    jit_order_date_added: string;
    jit_order_id: string;
    jit_cashcode_or_pin_info?: string;
    jit_terms_and_cond_text?: {
      content: string;
    };
    secret_code: string;
    pin_code: string | null;
    barcode_popup_url: string;
    seo_url: string;
  };
  handleModalBarcodeOpen: () => void;
}
const VoucherInfo: React.FC<VoucherInfoProps> = ({ voucherItem, handleModalBarcodeOpen }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Link href={`/product/${voucherItem.seo_url}`}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "600",
                fontSize: "17px",
                transition: "0.3s ease",
                "&:hover": { color: "primary.main" },
              }}
            >
              {voucherItem.product_name}
            </Typography>
          </Link>
          <Box sx={{ display: "flex", flexDirection: "column", mt: "10px" }}>
            <Typography variant="body2" sx={{ fontSize: "13px" }}>
              {voucherItem.jit_order_date_added}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "13px", mb: "10px" }}>
              {`Nr. ${voucherItem.jit_order_id}`}
            </Typography>
          </Box>
        </Box>

        <ImageWithFallback
          src={voucherItem.jit_product_image}
          alt={voucherItem.jit_product_name}
          width={100}
          height={80}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Box>

      {voucherItem.jit_cashcode_or_pin_info && (
        <Typography>{voucherItem.jit_cashcode_or_pin_info}</Typography>
      )}
      <VoucherCodes voucherItem={voucherItem} handleModalBarcodeOpen={handleModalBarcodeOpen} />
      {voucherItem.jit_terms_and_cond_text && (
        <TermsAndConditionsText content={voucherItem.jit_terms_and_cond_text.content} />
      )}
    </Box>
  );
};
export default VoucherInfo;
